module.exports = " <div class=main-title> <div class=title> <h1> Tabla {{title}} </h1> </div> <div class=button-group> <button md-ink-ripple class=\"md-btn md-raised\" ng-click=tableint.exportAll()> <i class=mdi-file-export></i>Exportar CSV </button> </div> </div> <div class=row> <div class=col-lg-12> <div class=panel> <div style=height:65vh class=t-h40 ui-grid=tabla ui-grid-pinning ui-grid-pagination ui-grid-resize-columns ng-if=tabla.data></div> </div> </div> <div class=col-xs-12> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/integration-front/tablesint/tableint.html
// module id = 850
// module chunks = 0